import { getFilterOption } from './getFilterOption'
import { getMakeOption } from './getMakeOption'
import { getAllModelOption } from './getAllModelOption'
import { getModelOption } from './getModelOption'
import { getTrimOption } from './getTrimOption'
import { detail } from './detail'
import { search } from './search'
import { searchByCategory } from './searchByCategory'
import { searchByBodyType } from './searchByBodyType'
import { searchByUsedMakeBodyType } from './searchByUsedMakeBodyType'
import { searchByUsedCategory } from './searchByUsedCategory'
import { searchBySeats } from './searchBySeats'
import { searchByPrice } from './searchByPrice'
import { searchBySavedQuery } from './searchBySavedQuery'
import { getSitemap } from './getSitemap'
import { getPopularMakeModelByType } from './getPopularMakeModelByType'

export const vehicleApi = {
  getFilterOption,
  getAllModelOption,
  getMakeOption,
  getModelOption,
  getTrimOption,
  detail,
  search,
  searchByCategory,
  searchBySeats,
  searchByPrice,
  searchByBodyType,
  searchByUsedMakeBodyType,
  searchByUsedCategory,
  searchBySavedQuery,
  getSitemap,
  getPopularMakeModelByType,
}
